<template>
  <div>
    <div id="active-page" :class="{'page-fade': !mountedPage}"></div>
    <modal-confirm-analyze
      :modal-img="modalConfirm"
      @analyze="analyze"
      @close-modal="modalConfirm = false"
      :tags="tags"
      :projects="selectedProject"
      :category="selectedCategory"
    ></modal-confirm-analyze>
    <v-form ref="form" v-model="valid">
      <v-container>
        <p class="headline">{{$t('titles.kindOfProject')}}</p>
        <div class="pb-4 no-outline">
          <template v-for="(cat, i) in categories">
          <v-btn
            flat
            icon
            style="width: 126px;"
            v-if="cat.value"
            large
            :key="i"
            @click="changeSelected(cat.key)"
          >
            <hexlong :color="cat.key === selectedCategory ? 'primary' : ''"></hexlong>
            <span style="z-index: 1;">{{cat.name}}</span>
          </v-btn>
          </template>
        </div>
        <p class="headline">{{$t('titles.kindAddTags')}}</p>
        <v-textarea
          my-4
          box
          name="input-7-1"
          :label="$t('labels.tags')"
          v-model="tags"
          :placeholder="$t('placeholders.tagsEx')"
          :rules="[v => !!v || $t('errors.fieldRequired')]"
        ></v-textarea>
        <v-layout>
          <v-flex md4 xs12>
            <itt-combobox @changeSelect="changeSelectedProj" :projects="projects"></itt-combobox>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <div class="double-buttons">
      <a @click="$router.push('preview')">
        <itt-arrow-btn :text="$t('buttons.back')" direction="left" />
      </a>
      <a @click="confirmAnalyze" class="d-flex">
        <itt-arrow-btn :text="$t('buttons.analyze')" direction="right" />
      </a>
    </div>
  </div>
</template>
<script>
import * as easings from "vuetify/es5/util/easing-patterns";
import hexagon from "../../components/icons/hexagon";
import analyze from "../../components/icons/analyze.vue";
import hexlong from "../../components/icons/hexlong";
import ittCombobox from "@/components/projects/itt-combobox";
import modalConfirmAnalyze from "@/components/modals-form/modal-infoimg";
import ittArrowBtn from "@/components/icons/arrow-btn";

export default {
  name: "pageNewProject",
  components: {
    hexagon,
    hexlong,
    analyze,
    ittCombobox,
    modalConfirmAnalyze,
    ittArrowBtn
  },
  created() {
    this.fetchData();
  },
  watch: {
    $router: "fetchData"
  },
  data() {
    return {
      valid: false,
      projects: [],
      selectedCategory: "leaflet",
      tags: "",
      selectedProject: "",
      validAnalyze: false,
      categories: [
        { key: 'reflex', value: process.env.VUE_APP_KIND_PROJECT_REFLEX, name: this.$t("buttons.reflex") },
        { key: 'natural', value: process.env.VUE_APP_KIND_PROJECT_NATURAL, name: this.$t("buttons.natural") },
        { key: 'packaging', value: process.env.VUE_APP_KIND_PROJECT_PACKAGING, name: this.$t("buttons.packaging") },
        { key: 'retail', value: process.env.VUE_APP_KIND_PROJECT_RETAIL, name: this.$t("buttons.retail") },
        // { key: 'ad', value: process.env.VUE_APP_KIND_PROJECT_AD, name: this.$t("buttons.ad") },
        { key: 'web', value: process.env.VUE_APP_KIND_PROJECT_WEB, name: this.$t("buttons.web") },
        // { key: 'magazine', value: process.env.VUE_APP_KIND_PROJECT_MAGAZINE, name: this.$t("buttons.magazine") },
        { key: 'leaflet', value: process.env.VUE_APP_KIND_PROJECT_LEAFLET, name: this.$t("buttons.leaflet") }
      ],
      toSelect: [],
      images: [],
      // loader: false,
      modalConfirm: false,
      mountedPage: false
    };
  },
  methods: {
    changeSelectedProj(newSelected) {
      this.selectedProject = newSelected;
    },
    // Récupération des projets (au created + router)
    // Quand projets récupérés, création du select parent/enfants
    // =================
    async fetchData() {
      this.projects = await this.$store.dispatch("project/getProjects");
      this.images = this.$store.getters["image/getPreviews"];
    },
    changeSelected(name) {
      this.selectedCategory = name;
    },
    validate() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          // SetTimeout pour laisser le temps de sortir le focus du select.
          if (!this.images.length) {
            resolve(false);
            this.$store.commit("dialogModal/toggleNotif", [
              this.$t("titles.noImage"),
              this.$t("texts.addAndRetry")
            ]);
            return;
          }
          this.$refs.form.validate();
          resolve(this.valid);
        }, 1);
      });
    },

    async confirmAnalyze() {
      if (!(await this.validate())) return;
      this.modalConfirm = true;
    },
    // Sélection ou bien ajout du dossier projet parent/enfant suivant qu'ils existent ou non et ajout des images dans ce projet.
    async analyze() {
      if (!(await this.validate())) {
        this.modalConfirm = false;
        return;
      }
      // this.loader = true;
      let projectToGo = await this.selectOrCreateProjects(
        this.selectedProject,
        this.projects
      );
      await this.analyzeUpload(this.images, projectToGo, this.selectedCategory);
      this.modalConfirm = false;
      this.$store.commit("image/initPreviews");
      this.$router.replace("projects/" + projectToGo.uuid);
      this.$store.commit("project/setLatestProj", projectToGo);
    }
  },
  mounted() {
    setTimeout(() => (this.mountedPage = true), 100);
  }
};
</script>

<style scoped>
.hexagon_svg {
  position: absolute;
  background: transparent;
  top: -20px;
  left: -5px;
  width: 50px;
  height: 50px;
  transition: 0.4s;
  fill: url("#blued-to-blue");
}

.hexagon_path {
  transform: scale(1.52) !important;
}
.hexagon_text {
  z-index: 1;
  position: absolute;
}
/* .loader {
  position: absolute;
  top: 0;
  bottom: -10%;
  text-align: center;
  width: 100%;
  z-index: 10;
}
.loader i {
  position: absolute;
  top: 70%;
  font-size: 3rem;
} */
</style>
